import { render } from "./AlternativeTherapies.vue?vue&type=template&id=7f5c2a8a"
import script from "./AlternativeTherapies.vue?vue&type=script&lang=js"
export * from "./AlternativeTherapies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__